import React from 'react';
import { Card } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.css';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import { Person, Menu, Favorite, Money, Theaters } from '@material-ui/icons';
import DashboardLineChart from '../../components/Chart/DashboardLineChart';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import HOCSectionLoader from '../../components/HOC/HOCSectionLoader.jsx';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import d1 from '../../assets/images/icon/d1.png';
import d2 from '../../assets/images/icon/d2.png';
import d3 from '../../assets/images/icon/d3.png';

const styles = theme => ({
    heading: {
        color: '#ffffff'
    },
    paper: {
        backgroundColor: theme.palette.primary.main
    },
    card: {
        color: theme.palette.secondary.main
    }
});
let isLoading = true;
class EarningList extends React.Component {
    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            menuState: false,
            weeklyData: [],
            monthlyData: [],
            yearlyData: [],
            loader: true
        };
    }
    componentDidMount() {
        this.getDashboardData();
    }
    getDashboardData = () => {
        this.props.providerEarningDataAction(
            { type: 1, datetime: new Date() },
            this.onWeeklyDone
        );
        this.props.providerCheckAction(this.onCheckDone);
    };

    onCheckDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            this.setState({ providerData: data.data.detail });
        }
    };

    onWeeklyDone = (success, data) => {
        if (success) {
            this.setState({ weeklyData: data.data[0].data }, () => {
                this.props.providerEarningDataAction(
                    { type: 2, datetime: new Date() },
                    this.onMonthlyDone
                );
            });
        }
    };
    onMonthlyDone = (success, data) => {
        if (success) {
            this.setState({ monthlyData: data.data[0].data }, () => {
                this.props.providerEarningDataAction(
                    { type: 3, datetime: new Date() },
                    this.onYearlyDone
                );
            });
        }
    };
    onYearlyDone = (success, data) => {
        if (success) {
            this.setState({ yearlyData: data.data[0].data, loader: false });
        }
    };

    onOptionMenuSelect = event => {
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose = () => {
        this.setState({ menuState: false });
    };

    render() {
        const { classes } = this.props;
        const {
            providerData,
            weeklyData,
            monthlyData,
            yearlyData
        } = this.state;
        return (
            <div className="tz-2-com tz-2-main">
                <h4>
                    <FormattedMessage
                        id="earningDashboard"
                        defaultMessage="Earning Dashboard"
                    />
                </h4>
                <div className="row">
                    <div className="col-lg-4 col-sm-6 col-12" />
                    <div className="col-lg-4 col-sm-6 col-12">
                        <Paper
                            elevation={1}
                            className={
                                classes.paper + ' ' + 'dashboard-small-box'
                            }
                        >
                            <h5 className={classes.heading}>
                                <FormattedMessage
                                    id="totalEarnings"
                                    defaultMessage="Total Earnings"
                                />
                                <span
                                    style={{
                                        fontSize: '25px'
                                    }}
                                >
                                    {' '}
                                    {
                                        this.props.settings.constants
                                            .CURRENCY_SYMBOL
                                    }
                                    {providerData &&
                                        providerData.provider_earning_amount}
                                </span>
                            </h5>
                        </Paper>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-12" />
                </div>
                <div className="db-list-com tz-db-table">
                    <div className="row">
                        <HOCSectionLoader loading={this.state.loader}>
                            <div className="col-md-12 text-left">
                                <h4>
                                    <FormattedMessage
                                        id="weeklyEarnings"
                                        defaultMessage="Weekly Earnings"
                                    />
                                </h4>
                                <DashboardLineChart
                                    data={weeklyData}
                                    {...this.props}
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <h4>
                                    <FormattedMessage
                                        id="monthlyEarnings"
                                        defaultMessage="Monthly Earnings"
                                    />
                                </h4>
                                <DashboardLineChart
                                    data={monthlyData}
                                    {...this.props}
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <h4>
                                    <FormattedMessage
                                        id="yearlyEarnings"
                                        defaultMessage="Yearly Earnings"
                                    />
                                </h4>
                                <DashboardLineChart
                                    data={yearlyData}
                                    {...this.props}
                                />
                            </div>
                        </HOCSectionLoader>
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = ({ settings }) => {
//     return {
//         colors: settings.colors
//     };
// };
const composedComponent = compose(
    withStyles(styles),
    withTheme(),
    connect(
        null,
        actions
    )
);

export default composedComponent(EarningList);



// WEBPACK FOOTER //
// ./src/views/User/ProviderEarning.jsx